query getMarketsAdmin($limit: Int, $offset: Int, $order: JSON) {
    getMarketsAdmin(order: $order, limit: $limit, offset: $offset)
}
